export default "__VITE_ASSET__CbFBXTQm__"